/* eslint-disable react-hooks/exhaustive-deps */
import {
  FORMAT_DATE_DEFAULT,
  FORMAT_TIME_DEFAULT,
  TimeFunction,
} from "@/common/datetime/TimeFunction";
import { BuildRCAttribute } from "@/common/function/RCAttribute";
import Canvas from "@/components/ui/Canvas";
import { ICanvasProps } from "@/components/ui/Canvas/Models";
import {
  RenderIconCalendar,
  RenderIconDismiss,
  RenderIconInfo,
  SelectedResourceIcon,
} from "@/components/ui/Icons/IconsCustom";
import ResourceItem from "@/components/ui/ResourceItem";
import TimeLine from "@/components/ui/TimeLine";
import { buildEventList } from "@/components/ui/TimeLine/constains/FunctionTimeline";
import { TimeRangeSliderCanvas } from "@/components/ui/TimeRangeSlider";
import { baContainer } from "@/ioc/RegisterRFServices";
import {
  IAppointmentManager,
  IOutlookSettingsRepository,
  TokenIAppointmentManager,
  TokenIOutlookSettingsRepository,
} from "@/out-look/interfaces";
import { RootState } from "@/redux";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { IResourceStore } from "@/redux/slices/resources/ResourceReducerModel";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { AppointmentByTimeRangeInfo, ResourceInfo } from "@/services/resource-service/entity/ResourceEntity";
import Availability from "@/view/addin/components/availability";
import ResourceCalendar from "@/view/addin/components/resource-calendar";
import { IRefComponentType } from "@/view/addin/components/resource-calendar/Models";
import ResourceDetail from "@/view/addin/components/resource-detail";
import { IRefComponentDetailType } from "@/view/addin/components/resource-detail/Models";
// import { Tooltip } from "@fluentui/react-components";
import { RefObject, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IResourceSelectedProps } from "./ResourceSelectedModel";
import {
  HeaderTitleWrapper,
  ResourceInfoWrapper,
  ResourceSelectedBaseWrapper,
  StickyElementWrapper,
} from "./Styles";
import { DateTimePeriod } from "@/services/organization-service/entity/OutLookEntity";
import IconPermission from "../components/icon-permission";
import TentativePermission from "../components/icon-permission/TentativeIcon";
// ... existing code ...
import OrderFormButtonContainer from "../order-form/OrderFormContainer";
import Nodata from "@/components/ui/Nodata";
// import { cloneDeep } from "lodash";
import { sortRs } from "@/common/function/ArrayFunction";
// import { Tooltip } from "@fluentui/react-components";
import ScrollDismissTooltip from "@/components/ui/Tooltip";
import { ITimeLineEvent } from "@/components/ui/TimeLine/Models";
import { cloneDeep } from "lodash";
// ... existing code ...
const ResourceSelected = (props: IResourceSelectedProps) => {
  const { t } = useTranslation();
  const refCalendar: RefObject<IRefComponentType | null> = useRef(null);
  const refDetail: RefObject<IRefComponentDetailType | null> = useRef(null);
  const resourceStore: IResourceStore = useSelector(
    (state: RootState) => state.resources
  ) as IResourceStore;

  const orgStore: IOrganizationStore = useSelector(
    (state: RootState) => state.orgInfo
  ) as IOrganizationStore;
  
  console.log("🚀 ~ ResourceSelected ~ orgStore:", orgStore)

  const settingStore: ISettingStore = useSelector(
    (state: RootState) => state.settingInfo
  ) as ISettingStore;
  const dateFormat = settingStore?.dateTimeFormat.dateTimeSeparator;
  const timeFormat = settingStore?.dateTimeFormat.timeFormat;
  const firstDayOfWeek = Number(
    settingStore?.dateTimeFormat.firstDayOfWeek || "0"
  );

  const [timeSlider, setTimeSlider] = useState(
    orgStore.outlookInfo?.displayStartTime || new Date()
  );
  const [eventNextDate, setEventNextDate] = useState<
    Record<string, { startDate: string[]; events: ITimeLineEvent[] }>
  >({});

  const resources: ResourceInfo[] | null = sortRs(resourceStore?.selectedResource || []);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setEventNextDate({});
    setTimeSlider(orgStore.outlookInfo?.displayStartTime || new Date());
  }, [orgStore.outlookInfo?.displayStartTime]);

  useEffect(() => {
    setIsOpen(!!resourceStore.selectedResource?.length);
    if (orgStore.orgInfo?.isExternal) {
      saveDataOnSessionOutlook();
    }
    setEventNextDate({});
    setTimeSlider(orgStore.outlookInfo?.displayStartTime || new Date());
  }, [
    JSON.stringify(resourceStore.selectedResource),
    JSON.stringify(orgStore.outlookInfo),
  ]);


  const saveDataOnSessionOutlook = (): void => {
    const outlookSettingsRepository: IOutlookSettingsRepository =
      baContainer.resolve(TokenIOutlookSettingsRepository);
    const appointmentManager: IAppointmentManager = baContainer.resolve(
      TokenIAppointmentManager
    );
    outlookSettingsRepository.SetAppSetting("dataResource", {
      resources: (resourceStore.selectedResource || []).map((resource) => {
        return {
          uid: resource.uuid,
          email: resource.email,
          showAs: resource.permission?.showAs,
        };
      }),
    });
    appointmentManager.SaveDataResourceInfo(
      {
        resources: (resourceStore.selectedResource || []).map(
          (resource) => resource.email
        ),
        startTime: orgStore.outlookInfo?.start,
        endTime: orgStore.outlookInfo?.end,
        startTimeNotConvert: orgStore.outlookInfo?.startTimeNotConvert,
        endTimeNotConvert: orgStore.outlookInfo?.endTimeNotConvert,
        occurrences: (orgStore.outlookInfo?.occurrences || [])?.map(
          (item: DateTimePeriod) => {
            return {
              StartTime: item.start?.toISOString() || "",
              EndTime: item.end?.toISOString() || "",
            };
          }
        ),
      },
      "data_resource"
    );
  };

  const args: ICanvasProps = {
    headerTitle: (
      <HeaderTitleWrapper className="HeaderTitleWrapper">
        <SelectedResourceIcon theme={settingStore.theme} />

        <span>{`${t("Resource Selected")} ${
          resources?.length ? `(${resources.length})` : ""
        }`}</span>
      </HeaderTitleWrapper>
    ),
    isStickHeader: false,
    isOpen: isOpen,
  };

  const renderHeaderButtons = (resource: ResourceInfo): JSX.Element => {
    return (
      <>
        {resource.permission.meetingDeclines?.length ? (
          <IconPermission
            permission={resource.permission}
            exchangeProperty={resource.exchangeProperty}
            isRecurring={orgStore.outlookInfo?.isRecurringMaster}
            quantityMeetingInfo={orgStore.outlookInfo?.occurrences?.length}
          />
        ) : null}
        {resource.permission.isTentative ? (
          <TentativePermission
            permission={resource.permission}
            theme={settingStore.theme || undefined}
          />
        ) : null}
        <div>
           <ScrollDismissTooltip  content={t("Calendar")} relationship="label">
            <div
              onClick={(ev: React.MouseEvent<HTMLImageElement>) =>
                onOpenCalendar(ev, resource)
              }
              {...BuildRCAttribute(`resource_item.${resource.name}.calendar`)}
            >
              <RenderIconCalendar theme={settingStore.theme} />
            </div>
          </ScrollDismissTooltip>
        </div>
         <ScrollDismissTooltip  content={t("View Details")} relationship="label">
          <div
            onClick={(ev: React.MouseEvent<HTMLImageElement>) =>
              onOpenResourceDetail(ev, resource)
            }
            {...BuildRCAttribute(`resource_item.${resource.name}.detail`)}
          >
            <RenderIconInfo theme={settingStore.theme} />
          </div>
        </ScrollDismissTooltip>
        {/*  <Tooltip  content={t("Add to My Favorites")} relationship="label">
          <div
            {...BuildRCAttribute(`resource_item.${resource.name}.favorites`)}
          >
            <RenderIconStar theme={settingStore.theme} />
          </div>
        </Tooltip> */}
         <ScrollDismissTooltip  content={t("Remove")} relationship="label">
          <div
            onClick={() => onDeleteSelectedResource(resource)}
            {...BuildRCAttribute(`resource_item.${resource.name}.remove`)}
          >
            <RenderIconDismiss theme={settingStore.theme} />
          </div>
        </ScrollDismissTooltip>
      </>
    );
  };

  const onDeleteSelectedResource = (resource: ResourceInfo): void => {
    if (props.deleteSelectResource) {
      props.deleteSelectResource(resource);
    }
  };

  const changeTime = async (timeSliderClone: Date) => {
    setTimeSlider(timeSliderClone);
    if(timeSlider.getDate() !== timeSliderClone.getDate()) {
      const currentDateClone = new Date(
        orgStore.outlookInfo?.displayStartTime || ""
      );
      const beforeCurrenDate = new Date(currentDateClone);
      beforeCurrenDate.setDate(currentDateClone.getDate() - 1);
      const afterCurrenDate = new Date(currentDateClone);
      afterCurrenDate.setDate(currentDateClone.getDate() + 1);
      const startDateNext: string = TimeFunction.dateTimeFormatter(timeSliderClone, FORMAT_DATE_DEFAULT) as string
  
      if (
        resources.length &&
        (!eventNextDate[resources[0].email]?.startDate?.length ||
          !eventNextDate[resources[0].email]?.startDate.includes(
            startDateNext
          )) &&
        (timeSliderClone <= beforeCurrenDate || timeSliderClone >= afterCurrenDate)
      ) {
        const resp = await onFetchAppointmentsByTimeRange(orgStore.orgInfo?.tenantId || "", timeSliderClone, resources.map(item => item.guid));
        const eventNextDateClone = cloneDeep(eventNextDate);
        resp.forEach(item => {
          if(!eventNextDateClone[item.resourceId] || (eventNextDateClone[item.resourceId] && !eventNextDateClone[item.resourceId].startDate.includes(startDateNext))) {
            const startDateClone = eventNextDateClone[item.resourceId]?.startDate || [];
            startDateClone.push(startDateNext)
            eventNextDateClone[item.resourceId] = {
              startDate: startDateClone,
              events: (eventNextDateClone[item.resourceId]?.events || []).concat(item.events || [])
            }
          }
        });
        setEventNextDate(eventNextDateClone);
      }
    }
  };

  const onFetchAppointmentsByTimeRange = async (
    tenantId: string,
    currentDate: Date,
    resourceIds: string[]
  ): Promise<AppointmentByTimeRangeInfo[]> => {
    if (props.onFetchAppointmentsByTimeRange) {
      const response = await props.onFetchAppointmentsByTimeRange(tenantId, currentDate, resourceIds);
      return response;
    }
    return [];
  }

  const onOpenCalendar = (
    ev: React.MouseEvent<HTMLImageElement>,
    resourceInfo: ResourceInfo
  ) => {
    ev.stopPropagation();
    if (refCalendar?.current?.onOpenResourceCalendar) {
      refCalendar?.current?.onOpenResourceCalendar(
        resourceInfo,
        orgStore.outlookInfo?.start || null
      );
    }
  };

  const onOpenResourceDetail = (
    ev: React.MouseEvent<HTMLImageElement>,
    resourceInfo: ResourceInfo
  ) => {
    ev.stopPropagation();
    if (refDetail?.current?.onOpenResourceDetail) {
      refDetail?.current?.onOpenResourceDetail(resourceInfo);
    }
  };

  return (
    <>
      <ResourceSelectedBaseWrapper
        className="ResourceSelectedBaseWrapper"
        $maxHeight={props.maxHeight}
      >
        <Canvas
          {...args}
          theme={settingStore.theme || undefined}
          rcName="resource_selected"
        >
          <>
            {resources?.length ? (
              resources?.map((resource: ResourceInfo, index: number) => {
                  return (
                    <ResourceInfoWrapper
                      key={resource.guid}
                      className="ResourceInfoWrapper"
                      $isLastChild={
                        index === resources.length - 1 &&
                        !orgStore.outlookInfo?.isRecurringMaster
                      }
                    >
                      <ResourceItem
                        isSelected={true}
                        id={resource.guid}
                        avatar=""
                        name={`${resource.displayName || resource.name}`}
                        isShowClosingIcon={true}
                        model={resource}
                        leftBorderStyle={
                          orgStore.outlookInfo?.isRecurringMaster
                            ? resource.calculateBorderRecurring(
                                orgStore.outlookInfo?.occurrences?.length || 0
                              )
                            : resource.calculateBorder
                        }
                        isShowTimeLine={
                          !orgStore.outlookInfo?.isRecurringMaster
                        }
                        headerButtons={renderHeaderButtons(resource)}
                        theme={settingStore.theme || undefined}
                        availabilityBox={
                          <Availability
                            resource={resource}
                            meetingInfos={orgStore.outlookInfo?.occurrences}
                            dateFormat={settingStore?.dateTimeFormat?.dateTimeSeparator}
                          />
                        }
                        buttonOrderFormElement={orgStore.orgInfo?.resourceCentralEndpoint && resource.isRCRegistered && !orgStore.orgInfo?.disableOrderExternal ?
                          <OrderFormButtonContainer Resource={resource} /> : undefined
                        }
                        timeLineElements={
                          <TimeLine
                            timeSlider={timeSlider}
                            startTimeSelected={
                              orgStore.outlookInfo?.displayStartTime ||
                              new Date()
                            }
                            endTimeSelected={
                              orgStore.outlookInfo?.displayEndTime || new Date()
                            }
                            localizer="en-US"
                            isNoInformation={true}
                            dateTimeFormat={{
                              dateFormat: dateFormat || FORMAT_DATE_DEFAULT,
                              timeFormat: timeFormat || FORMAT_TIME_DEFAULT,
                            }}
                            events={buildEventList(timeSlider, resource, {
                              startTime: new Date(
                                orgStore.outlookInfo?.displayStartTime || ""
                              ),
                              endTime: new Date(
                                orgStore.outlookInfo?.displayEndTime || ""
                              ),
                            }).concat(eventNextDate[resource.guid]?.events || [])}
                            exchangePropertyResource={resource.exchangeProperty}
                          />
                        }
                      />
                    </ResourceInfoWrapper>
                  );
                })
            ) : (
              <div className="nodata">
                <Nodata />
              </div>
            )}
            {!orgStore.outlookInfo?.isRecurringMaster && resources.length ? (
              <StickyElementWrapper
                className="StickyElementWrapper"
                $theme={settingStore.theme || undefined}
              >
                <TimeRangeSliderCanvas
                  key="resourceSelected"
                  startTimeSelected={timeSlider}
                  format={dateFormat || FORMAT_DATE_DEFAULT}
                  formatHour={timeFormat || FORMAT_TIME_DEFAULT}
                  onChange={changeTime}
                  theme={settingStore.theme || undefined}
                  rcName="resource_selected"
                />
              </StickyElementWrapper>
            ) : null}
          </>
        </Canvas>
      </ResourceSelectedBaseWrapper>
      <ResourceCalendar
        ref={refCalendar}
        dateFormat={dateFormat}
        timeFormat={timeFormat}
        firstDayOfWeek={firstDayOfWeek}
      />
      <ResourceDetail ref={refDetail} />
    </>
  );
};

export default ResourceSelected;
